import { useQuery } from '@tanstack/react-query';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapWeekdayDaypart } from './helper';

export const useGetWeekdayDayparts = (overrideQuerySetting = {}) =>
  useQuery({
    queryKey: queryKeys.weekdayDayparts.all(),
    queryFn: fetchWeekdayDayparts,
    ...overrideQuerySetting,
  });

export const fetchWeekdayDayparts = async () => {
  const url = `/weekdayDayparts${generateQuery(
    ['dayparts', 'weekdays'],
    ['pageSize=0'],
  )}`;

  const response = await requestCCApi({ url });

  return mapWeekdayDaypart(response);
};
